import script from "./news.vue?vue&type=script&setup=true&lang=ts"
export * from "./news.vue?vue&type=script&setup=true&lang=ts"

import "./news.vue?vue&type=style&index=0&id=4cd03a17&lang=scss&scoped=true"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cd03a17"]])

export default __exports__